import type { VoidFunctionComponent } from 'react';

import { ModalViewRelationshipsBody } from '../../../dependencies/ModalViewRelationships';

import { VendoredPaths } from './VendoredPaths';

import styles from '../DependencyDrawer.module.less';

type DependencyPathsProps = {
  rootProjectLocator: string;
  dependencyLocator: string;
  dependencyTitle: string;
  vendoredPaths?: string[];
};

export const DependencyPaths: VoidFunctionComponent<DependencyPathsProps> = ({
  rootProjectLocator,
  dependencyLocator,
  dependencyTitle,
  vendoredPaths,
}) => {
  const revision = {
    locator: dependencyLocator,
    project: {
      title: dependencyTitle,
    },
  };
  return (
    <>
      <div className={styles.header}>Paths</div>
      {vendoredPaths?.length ? (
        <VendoredPaths dependencyTitle={dependencyTitle} vendoredPaths={vendoredPaths} />
      ) : (
        <ModalViewRelationshipsBody parentLocator={rootProjectLocator} revision={revision} />
      )}
    </>
  );
};
